import { render, staticRenderFns } from "./AvaliacaoEdit.vue?vue&type=template&id=29e38731&scoped=true"
import script from "./AvaliacaoEdit.vue?vue&type=script&lang=js"
export * from "./AvaliacaoEdit.vue?vue&type=script&lang=js"
import style0 from "./AvaliacaoEdit.vue?vue&type=style&index=0&id=29e38731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e38731",
  null
  
)

export default component.exports